<div class="add-custom-field {{EditView ? 'update-view' : ''}}">
    <form [formGroup]="addCustomFieldForm">
        <div class="add-custom-field-header d-flex align-items-center justify-content-between">
            <h4>{{fieldId > 0 ? 'Field' : 'Add New Custom Field'}}</h4>
            <div class="d-flex align-items-center gap-1">
                <button type="button" class="btn basic-btn btn-xs" (click)="cancel()">Cancel</button>
                <button type="button" [disabled]="!addCustomFieldForm.valid || isArchived" class="btn primary-btn btn-xs"
                    (click)="addUpdateField()">Save</button>
            </div>

        </div>

        <div class="add-custom-field-form">

            <div class="admin-name-actions carrier-user-action">
                <div class="row custom-field" [class.archived-view]="isArchived" [class.add-new-field]="fieldId == 0">
                    <div class="col-12">
                        <div class="select-options mb-2">
                            <label for="inputTypeId">{{fieldId > 0 ? 'Input type' : 'Select input type'}}<span *ngIf="fieldId == 0 && !isArchived" class="validation-field">*</span></label>
                            <div class="select-block">
                                <ng-select [searchable]="true" [class.open-top]="!EditView && fieldCount > 8" [clearable]="true" formControlName="fieldTypeId" [class.disabled]="fieldId > 0"
                                    (change)="onFieldTypeChange()" placeholder="Select input type" name="inputTypeId"
                                    class="form-control">
                                    <ng-option *ngFor="let type of fieldTypeList" [value]="type.fieldTypeId">{{ type.displayName }}</ng-option>
                                </ng-select>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="input-block mb-2">
                            <label class="input-label">Label<span *ngIf="!isArchived"  class="validation-field">*</span></label>
                            <input type="text" formControlName="label" class="form-control" placeholder="Enter label"
                                name="label" maxlength="100" [class.disabled]="isArchived" />
                        </div>
                    </div>

                    <div class="col-12" *ngIf="showPlaceholder">
                        <div class="input-block mb-2">
                            <label class="input-label">Placeholder<span *ngIf="!isArchived" class="validation-field">*</span></label>
                            <input type="text" formControlName="placeholder" class="form-control" [class.disabled]="isArchived" 
                                placeholder="Enter custom placeholder" name="placeholder" maxlength="100" />
                        </div>
                    </div>

                    <div class="col-12" *ngIf="isDropdown">
                        <div class="input-block mb-2">
                            <label class="input-label">Options<span *ngIf="!isArchived" class="validation-field">*</span></label>
                            <ng-container *ngFor="let option of options">
                                <input type="text" class="form-control mb-1" [id]="'input-' + option.id"  [(ngModel)]="option.text" [class.disabled]="isArchived"
                                    [ngModelOptions]="{standalone:true}" style="position: relative; padding-right: 36px;"
                                    [placeholder]="option.placeholder" name="option.id" maxlength="100" />
                                <span class="close-icon" (click)="clearOption(option.id)">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                        <rect _ngcontent-wvn-c189="" width="20" height="20" rx="6" fill="none"></rect>
                                        <g _ngcontent-wvn-c189="" transform="translate(4 4)">
                                            <rect _ngcontent-wvn-c189="" width="16" height="16" fill="none"></rect>
                                            <path _ngcontent-wvn-c189=""
                                                d="M10,11.229,5.979,15.25a.789.789,0,0,1-.6.24.863.863,0,0,1-.6-.261.88.88,0,0,1,0-1.229l4-4L4.75,5.979a.8.8,0,0,1-.24-.614.875.875,0,0,1,.261-.615A.88.88,0,0,1,6,4.75l4,4.021L14.021,4.75A.869.869,0,0,1,15.25,5.979L11.229,10l4.021,4.021a.855.855,0,0,1,0,1.208.88.88,0,0,1-1.229,0Z"
                                                transform="translate(-0.005 0.005)" fill="#9e9e9e"></path>
                                        </g>
                                    </svg>
                                </span>
                            </ng-container>
                        </div>

                        <button type="button" class="btn secondary-btn btn-sm w-100 justify-content-center mb-2"
                            (click)="addOption()" [class.disabled]="isArchived">
                            Add Option
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10 15.625C9.81944 15.625 9.67028 15.5661 9.5525 15.4483C9.43417 15.33 9.375 15.1806 9.375 15V10.625H5C4.81944 10.625 4.67028 10.5658 4.5525 10.4475C4.43417 10.3297 4.375 10.1806 4.375 10C4.375 9.81944 4.43417 9.67 4.5525 9.55167C4.67028 9.43389 4.81944 9.375 5 9.375H9.375V5C9.375 4.81944 9.43417 4.67028 9.5525 4.5525C9.67028 4.43417 9.81944 4.375 10 4.375C10.1806 4.375 10.33 4.43417 10.4483 4.5525C10.5661 4.67028 10.625 4.81944 10.625 5V9.375H15C15.1806 9.375 15.33 9.43389 15.4483 9.55167C15.5661 9.67 15.625 9.81944 15.625 10C15.625 10.1806 15.5661 10.3297 15.4483 10.4475C15.33 10.5658 15.1806 10.625 15 10.625H10.625V15C10.625 15.1806 10.5661 15.33 10.4483 15.4483C10.33 15.5661 10.1806 15.625 10 15.625Z"
                                    fill="#0068D8" />
                            </svg>
                        </button>
                    </div>


                    <!-- <div class="col-12 my-2">
                        <div class="input-block custom-control custom-checkbox" [class.disabled]="isArchived">
                            <input type="checkbox" class="custom-control-input" id="isRequired" name="isRequired"
                                formControlName="isRequired">
                            <label class="custom-control-label" for="isRequired">
                                Is Required
                            </label>

                        </div>
                    </div> -->
                    </div>
                <div class="row" [class.d-none]="fieldId == 0">
                    <div class="col-12 border-x" *ngIf="fieldId || EditView">
                      <!-- <div class="d-flex align-items-center gap-1" [class.mb-3]="fieldId > 0">
                        <button type="button" class="btn basic-btn btn-xs" (click)="cancel()">Cancel</button>
                        <button type="button" [disabled]="!addCustomFieldForm.valid || isArchived" class="btn primary-btn btn-xs"
                                (click)="addUpdateField()">
                          Save
                        </button>
                      </div> -->

                    <button type="button" class="btn secondary-btn btn-sm w-100 justify-content-center mb-2" *ngIf="fieldId"
                        (click)="archiveCustomField()" [class.d-none]="isArchived">
                        Archive
                        <!-- <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.0003 8.57379C9.82296 8.57379 9.67446 8.63362 9.55481 8.75327C9.43515 8.87294 9.37533 9.02144 9.37533 9.19879V12.2821L8.27272 11.1796C8.15735 11.0642 8.01232 11.0051 7.83764 11.0025C7.66297 10.9998 7.51528 11.0588 7.39456 11.1796C7.27382 11.3003 7.21345 11.4466 7.21345 11.6186C7.21345 11.7906 7.27382 11.937 7.39456 12.0577L9.47308 14.1362C9.62372 14.2869 9.79946 14.3622 10.0003 14.3622C10.2012 14.3622 10.3769 14.2869 10.5275 14.1362L12.6061 12.0577C12.7214 11.9424 12.7805 11.7973 12.7831 11.6226C12.7858 11.448 12.7268 11.3003 12.6061 11.1796C12.4853 11.0588 12.339 10.9985 12.167 10.9985C11.995 10.9985 11.8486 11.0588 11.7279 11.1796L10.6253 12.2821V9.19879C10.6253 9.02144 10.5655 8.87294 10.4458 8.75327C10.3262 8.63362 10.1777 8.57379 10.0003 8.57379ZM4.16697 6.5866V15.577C4.16697 15.6517 4.19101 15.7132 4.2391 15.7613C4.28718 15.8094 4.34862 15.8334 4.42341 15.8334H15.5772C15.652 15.8334 15.7134 15.8094 15.7615 15.7613C15.8096 15.7132 15.8336 15.6517 15.8336 15.577V6.5866H4.16697ZM4.48751 17.0834C4.07192 17.0834 3.70626 16.9255 3.39055 16.6098C3.07485 16.2941 2.91699 15.9284 2.91699 15.5129V5.83823C2.91699 5.65981 2.94558 5.48967 3.00274 5.32781C3.05989 5.16596 3.14563 5.01666 3.25995 4.87991L4.42983 3.46483C4.56658 3.28642 4.73751 3.15046 4.94264 3.05698C5.14776 2.96349 5.36465 2.91675 5.59328 2.91675H14.3913C14.6199 2.91675 14.8381 2.96349 15.046 3.05698C15.2537 3.15046 15.426 3.28642 15.5628 3.46483L16.7407 4.89594C16.855 5.03269 16.9407 5.18332 16.9979 5.34785C17.055 5.51238 17.0836 5.68385 17.0836 5.86227V15.5129C17.0836 15.9284 16.9258 16.2941 16.6101 16.6098C16.2943 16.9255 15.9287 17.0834 15.5131 17.0834H4.48751ZM4.49228 5.33662H15.5003L14.5916 4.25487C14.5649 4.22817 14.5342 4.2068 14.4995 4.19077C14.4648 4.17474 14.4287 4.16673 14.3913 4.16673H5.6013C5.5639 4.16673 5.52784 4.17474 5.49312 4.19077C5.4584 4.2068 5.42767 4.22817 5.40095 4.25487L4.49228 5.33662Z" fill="#0068D8" />
                        </svg> -->
                    </button>


                      <ng-container *ngIf="fieldId">
                      <p class="m-0 last-updated-date">
                        Created by
                        <span class="dark-gray-text">{{fieldDetail?.createdByName}}</span>
                        on
                        <span class="dark-gray-text">
                          {{fieldDetail?.createdOn | date:'MM/dd/yyyy h:mm a'}}
                        </span>
                      </p>

                      <p class="m-0 last-updated-date"
                         *ngIf="fieldDetail?.modifiedBy">
                        Updated by
                        <span class="dark-gray-text">{{fieldDetail?.modifiedByName}}</span>
                        on
                        <span class="dark-gray-text">
                          {{fieldDetail?.modifiedOn | date:'MM/dd/yyyy h:mm a'}}
                        </span>
                      </p>

                      <p class="m-0 last-updated-date"
                         *ngIf="fieldDetail?.archivedBy">
                        Archived by
                        <span class="dark-gray-text">{{fieldDetail?.archivedByName}}</span>
                        on
                        <span class="dark-gray-text">
                          {{fieldDetail?.archivedOn | date:'MM/dd/yyyy h:mm a'}}
                        </span>
                      </p>
                      </ng-container>
                    </div>
                </div>




            </div>

            <!-- <validation-summary [validationErrors]="errorMessages"></validation-summary> -->

        </div>
    </form>
</div>
